import {Component, Input, OnInit} from '@angular/core';
import {UserDtoExtended} from "@esa/api";
import {environment} from "../../../../../environments/environment";
import {UserDto} from "@esa/api/models/UserDto";

@Component({
  selector: 'app-support-component',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent {
   @Input() loggedInUser: UserDtoExtended;
   @Input() users: UserDto[];

   fiuHoa : UserDto;

   supportEmailAddress = environment.supportEmailAddress;


   getHoA() : boolean {
     this.users?.map((user) => {
       if (user?.role?.roleName.toLowerCase().includes("hoa")) {
         this.fiuHoa = user;
         console.log("Hoa: ", this.fiuHoa)
         return true;
       }
       else {
         return false;
       }
     })

     return false;
   }
}
